module.exports = __webpack_public_path__ + "img/Invasion-BLCA_GSE171351.84509e88.png";